var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('router-link',{staticClass:"product-item",attrs:{"to":{ name: 'product', params: { slug: _vm.itemData.translations[0].slug } }}},[_c('picture',{style:({
            backgroundImage: `url(${_vm.$assets}/${_vm.itemData.translations[0].cover})`,
        })},[_c('span',{domProps:{"textContent":_vm._s(_vm.itemData.translations[0].name)}})])])
}
var staticRenderFns = []

export { render, staticRenderFns }